export * from "./DeviceDetectHelper";
export * from "./MarketGetter";